import { request } from "@/utils/request";

// 用户登录
export const loginApi = (data) => {
  return request.post("/super-words/user/userLogin", data);
};

// 用户修改密码
export const editPasswordApi = (data) => {
  return request.post("/super-words/user/coach-updatePassword", data);
};

// 发送验证码
export const sendSmsCode = (data) => {
  return request.get("/super-words/user/sendSmsCode", data);
};

// 验证验证码
export const verifyCode = (data) => {
  return request.post("/super-words/user/coach-verifyCode", data);
};

// 忘记密码、修改密码
export const forgetPasswordApi = (data) => {
  return request.post("/super-words/user/coach-forgetPassword", data);
};

// 获取海报
export const getPosterTemplateApi = (data) => {
  return request.get("/super-words/user/getPosterTemplate", data);
};

// 获取工作时间
export const getMyWorkDatesApi = (data) => {
  return request.get("/super-words/user/getMyWorkDates", data);
};

// 获取工作时间详情
export const getMyWorkInfoApi = (data) => {
  return request.get("/super-words/user/getMyWorkTime", data);
};

// 添加教练工作时间
export const addCoachWorkTimeApi = (data) => {
  return request.post("/super-words/user/addWorkTime", data);
};

// 获取测试记录列表
export const getEvaluationListApi = (data) => {
  return request.get("/super-words/evaluation/list", data);
};

// 获取休假记录列表
export const getCoachLeaveListApi = (data) => {
  return request.get("/super-words/coach_leave_request/list", data);
};

// 删除休假记录
export const deleteCoachLeaveApi = (data) => {
  return request.delete("/super-words/coach_leave_request/delete", data);
};

// 导出PDF
export const exportPdfApi = (data) => {
  return request.post("/super-words/words/exportPdf", data);
};
